import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject, Prop, Watch} from 'vue-property-decorator'
import Api from '@/services/Api'
import _ from 'lodash'
import {Errors} from '@/utils/Errors'

@Component
export default class Form<ModelDraftType extends object> extends Vue
{
    @Inject('api')
    protected api!: Api

    @Prop({required: true, type: Object})
    value!: ModelDraftType

    @Prop({type: Object, default: () => ({})})
    errors!: Errors

    model: ModelDraftType = this.createModel()

    @Watch('value', {deep: true, immediate: true})
    onValueChanged(value: ModelDraftType) {
        if (!_.isEqual(value, this.model)) {
            this.valueChanged(value)
        }
    }

    valueChanged(value: ModelDraftType) {
        this.model = {...value}
    }

    @Watch('model', {deep: true})
    onModelChanged(model: ModelDraftType) {
        if (!_.isEqual(model, this.value)) {
            this.$emit('input', model)
        }
    }

    createModel(): ModelDraftType {
        throw 'Метод createModel не реализован!'
    }

    errorsFor(prop: string): string[] {
        return this.errors?.[prop]
    }
}